import {StyleParamType, wixColorParam, wixFontParam, createStylesParams} from '@wix/tpa-settings'

export type GeneralStylesParams = {
  generalTitleFont: StyleParamType.Font
  generalTitleColor: StyleParamType.Color
  generalSubtitleFont: StyleParamType.Font
  generalSubtitleColor: StyleParamType.Color
  generalSecondaryTitleFont: StyleParamType.Font
  generalSecondaryTitleColor: StyleParamType.Color
  generalBodyFont: StyleParamType.Font
  generalBodyColor: StyleParamType.Color
}

export const generalStylesParams = createStylesParams<GeneralStylesParams>({
  generalTitleFont: {
    type: StyleParamType.Font,
    inheritDesktop: false,
    getDefaultValue: (params) =>
      wixFontParam('Page-title', {
        htmlTag: 'h1',
        size: params.isMobile ? 28 : 32,
      })(params),
  },
  generalTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  generalSubtitleFont: {
    type: StyleParamType.Font,
    inheritDesktop: false,
    getDefaultValue: wixFontParam('Body-M', {size: 16, htmlTag: 'p'}),
  },
  generalSubtitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  generalSecondaryTitleFont: {
    type: StyleParamType.Font,
    inheritDesktop: false,
    getDefaultValue: wixFontParam('Body-M', {size: 16, htmlTag: 'h2'}),
  },
  generalSecondaryTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  generalBodyFont: {
    type: StyleParamType.Font,
    inheritDesktop: false,
    getDefaultValue: wixFontParam('Body-M', {size: 16}),
  },
  generalBodyColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
})
